"use client";

import { c as _c } from "react/compiler-runtime";
import type { TocEntry } from "@modules/article/lib/toArticleView";
import { useEffect, useRef, useState } from "react";
import { CARD, LABEL } from "../styles";
const useActiveSection = ids => {
  const $ = _c(5);
  let t0;
  if ($[0] !== ids) {
    t0 = ids.split(" ");
    $[0] = ids;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [active, setActive] = useState(t0[0]);
  let t1;
  let t2;
  if ($[2] !== ids) {
    t1 = () => {
      const headings = ids.split(" ").map(_temp).filter(_temp2);
      if (!headings.length) {
        return;
      }
      const observer = new IntersectionObserver(entries => {
        const [hit] = entries.filter(_temp3).sort(_temp4);
        if (hit) {
          setActive(hit.target.id);
        }
      }, {
        rootMargin: "-96px 0px -66% 0px",
        threshold: 0
      });
      headings.forEach(heading_0 => observer.observe(heading_0));
      return () => observer.disconnect();
    };
    t2 = [ids];
    $[2] = ids;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  return active;
};
const TableOfContents = t0 => {
  const $ = _c(18);
  const {
    items,
    label
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp5).join(" ");
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const active = useActiveSection(t1);
  const list = useRef(null);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const entry = list.current?.querySelector("[aria-current]");
      if (!list.current || !entry) {
        return;
      }
      const {
        offsetTop,
        offsetHeight
      } = entry;
      const {
        scrollTop,
        clientHeight
      } = list.current;
      if (offsetTop < scrollTop || offsetTop + offsetHeight > scrollTop + clientHeight) {
        list.current.scrollTop = offsetTop - clientHeight / 3;
      }
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== active) {
    t3 = [active];
    $[3] = active;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== label) {
    t4 = <p className={`${LABEL} flex-none`}>{label}</p>;
    $[5] = label;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== active || $[8] !== items) {
    let t6;
    if ($[10] !== active) {
      t6 = item_0 => {
        const current = item_0.id === active;
        return <li key={item_0.id}><a href={`#${item_0.id}`} aria-current={current ? "location" : undefined} className={`block text-body-2 no-underline transition-colors focusable ${current ? "text-neutral-675 font-semibold" : "text-neutral-425 font-book hover:text-primary-800"}`}>{item_0.label}</a></li>;
      };
      $[10] = active;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = items.map(t6);
    $[7] = active;
    $[8] = items;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = <ol ref={list} className="relative mt-2s grid gap-2xs list-none p-none m-none min-h-[0] overflow-y-auto">{t5}</ol>;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== label || $[15] !== t4 || $[16] !== t6) {
    t7 = <nav aria-label={label} className={`${CARD} p-3s min-h-[0] flex flex-col`}>{t4}{t6}</nav>;
    $[14] = label;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default TableOfContents;
function _temp(id) {
  return document.getElementById(id);
}
function _temp2(heading) {
  return !!heading;
}
function _temp3(entry) {
  return entry.isIntersecting;
}
function _temp4(a, b) {
  return a.boundingClientRect.top - b.boundingClientRect.top;
}
function _temp5(item) {
  return item.id;
}